import styled from 'styled-components'

import ButtonBase from '../button-base'

const StyledIconButton = styled(ButtonBase)`
  background-color: transparent;
  border: none;
`

export { StyledIconButton }
